module.exports = __webpack_public_path__ + "img/1557407742.16ce5333.jpg";